import React from 'react'
import {Form, Button, Space,Input} from 'antd';
import GetClient from '../client/GetClient';
import GetUserDept from '../../cpn/GetUserDept';
import FormItemBalanceType from '../../cpn/FormItemBalanceType';
function BalanceQuery(props) {
    const [form] = Form.useForm();
    return (
        <Form 
            form={form}
            layout="inline"
            name="form_in_modal"
            initialValues={{                        
                eie_client_id:'',
                eie_dept_id:'',
                eie_type_id:'',
                eie_finance_sub_type_id:'',
            }}
            onFinish={() => {
                form
                    .validateFields()
                    .then((values) => {
                        props.getBalanceQuery(values);
                    })
                    .catch((info) => {
                        console.log('Validate Failed:', info);
                    });
            }}
        >
            <GetClient
                label='客户'  
                wrapperCol={{span:12}} 
                name='eie_client_id' 
                style={{width:'200px'}} 
                getClient={(e) => {}} 
                setClient={true}
                placeholder='填写名称关键字并选择'
            /> 
            <GetUserDept
                label='部门' 
                wrapperCol={{span:19}}
                getUserDept={(e) => {}}
                name='eie_dept_id'
                style={{width:"200px"}}
                setDept={true}
                FormStyle={{width:"200px"}}
                labelCol={{span:7}}
            />
            <FormItemBalanceType
                mainName='eie_type_id'
                subName='eie_finance_sub_type_id'
                labelCol={{span:6}}
                getMainType={() => {}}
                getSubType={() => {}}
            />
            <Form.Item
                label='备注'
                labelCol={{span:10}}
                wrapperCol={{span:14}}
                name='eie_content'
            >
                <Input placeholder='' />
            </Form.Item>
            <Form.Item
                wrapperCol={{offset:9}}
            >
                <Space>
                    <Button
                        htmlType='submit'
                    >
                        查询
                    </Button>
                    <Button onClick={() => { 
                        form.resetFields();
                        props.getBalanceQuery({
                            eie_client_id:'',
                            eie_dept_id:'',
                            eie_type_id:'',
                            eie_finance_sub_type_id:'',
                            eie_content:'',
                        })              
                        }}>重置</Button>
                </Space>
            </Form.Item>    
        </Form>
    )
}

export default BalanceQuery